import { userConstants as USER } from "../_constants";

/**
 * Returns true when the given ddi/nationality identifies a country
 * that should use the simplified registration flow (shortForm).
 *
 * Accepts both string and number for `ddi` — callers store it
 * inconsistently across the app (form input as string, persisted
 * user data sometimes as number).
 *
 * Either input may be undefined; the function never throws.
 */
export function isShortFormCountry({ ddi, nationality } = {}) {
    const ddiStr = ddi != null ? String(ddi) : undefined;

    return (
        USER.SHORT_FORM_DDIS.includes(ddiStr) ||
        USER.SHORT_FORM_NATIONALITIES.includes(nationality)
    );
}
